module.exports = __webpack_public_path__ + "static/fk_video1b-d35508f7c3b007f5fd466eb034a39f98.png";